import styled, { css } from 'styled-components';

const ButtonWrapper = styled.button `
    padding: 0 ${({ theme }) => theme.spacers.L};
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
    height: 48px;
    min-width: 85px;
    background-color: ${({ theme }) => theme.colors.background.white};
    color: ${({ theme }) => theme.colors.text.darkerGrey};
    ${({ theme }) => theme.typography.RegularParagraphBold};
    line-height: 1.25;
    text-align: center;
    text-decoration: none;
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.full};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacers.M};
    outline: none;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform 100ms cubic-bezier(0.2, 0, 0, 1);

    > svg {
        flex-shrink: 0;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.hover.lighterGrey};
    }

    &:active {
        transform: scale(0.96);
    }

    &:focus-visible {
        box-shadow: ${({ theme }) => theme.shadows.focused};
        transition: box-shadow 200ms cubic-bezier(0.2, 0, 0, 1);
    }

    &:disabled {
        background-color: ${({ theme }) => theme.colors.background.superLightGrey};
        color: ${({ theme }) => theme.colors.text.baseGrey};
        box-shadow: none;
        cursor: not-allowed;

        &:hover {
            background-color: ${({ theme }) => theme.colors.background.superLightGrey};
            color: ${({ theme }) => theme.colors.text.baseGrey};
            box-shadow: none;
        }

        &:active {
            transform: none;
        }
    }

    ${({ $size }) => {
    if ($size === 'S') {
        return css `
                height: 32px;
            `;
    }
    else if ($size === 'M') {
        return css `
                height: 40px;
            `;
    }
    return css `
            min-width: 100px;
        `;
}}

    ${({ $variant, theme }) => {
    if ($variant === 'Red') {
        return css `
                background-color: ${theme.colors.background.baseExciteRed};
                color: ${theme.colors.text.white};

                &:hover {
                    background-color: ${theme.colors.hover.darkExciteRed};
                }
            `;
    }
    else if ($variant === 'Primary') {
        return css `
                background-color: ${theme.colors.background.darkerGrey};
                color: ${theme.colors.text.white};

                &:hover {
                    background-color: ${theme.colors.hover.superDarkGrey};
                }
            `;
    }
    else if ($variant === 'SecondaryOutlined') {
        return css `
                box-shadow: inset 0 0 0 2px ${theme.colors.stroke.darkerGrey};

                &:focus-visible {
                    box-shadow: inset 0 0 0 2px ${theme.colors.stroke.darkerGrey},
                        ${theme.shadows.focused};
                }
            `;
    }
    else if ($variant === 'Grey') {
        return css `
                background-color: ${theme.colors.background.superLightGrey};

                &:hover {
                    background-color: ${theme.colors.hover.lighterGrey};
                }
            `;
    }
    else if ($variant === 'Ghost') {
        return css `
                padding: 0 ${({ theme }) => theme.spacers.M};
                background-color: transparent;
                text-decoration: underline;

                &:hover {
                    background-color: transparent;
                    color: ${theme.colors.hover.superDarkGrey};
                }

                &:disabled {
                    background-color: transparent;

                    &:hover {
                        background-color: transparent;
                    }
                }
            `;
    }
    else if ($variant === 'GhostDarkBackground') {
        return css `
                padding: 0 ${({ theme }) => theme.spacers.M};
                background-color: transparent;
                color: ${theme.colors.text.white};
                text-decoration: underline;

                &:hover {
                    background-color: transparent;
                }

                &:disabled {
                    background-color: transparent;

                    &:hover {
                        background-color: transparent;
                    }
                }
            `;
    }
    return css ``;
}}

    ${({ $shadow, $variant, theme }) => {
    if (!$shadow)
        return css ``;
    if ($variant === 'SecondaryOutlined') {
        return css `
                box-shadow: inset 0 0 0 2px ${theme.colors.stroke.darkerGrey},
                    ${theme.shadows.normal};

                &:hover {
                    box-shadow: inset 0 0 0 2px ${theme.colors.stroke.darkerGrey},
                        ${theme.shadows.strong};
                }
            `;
    }
    return css `
            box-shadow: ${theme.shadows.normal};

            &:hover {
                box-shadow: ${theme.shadows.strong};
            }
        `;
}}

    ${({ $iconOnly, $size }) => {
    if (!$iconOnly)
        return css ``;
    if ($size === 'S') {
        return css `
                padding: 0;
                min-width: 32px;
            `;
    }
    else if ($size === 'M') {
        return css `
                padding: 0;
                min-width: 40px;
            `;
    }
    return css `
            padding: 0;
            min-width: 48px;
        `;
}}
`;
styled.div `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacers.L};
    min-width: 0;
`;

export { ButtonWrapper };
